import React from 'react';
import { Provider } from 'react-redux';
import { getOverviewInfo } from '@redux/modules/overviewInfo';
import Store from '@redux';

import OverviewInfoContent from './components/OverviewInfoContent';

class OverviewInfo extends React.Component {
  constructor(props) {
    super(props);

    this.store = Store.get();
  }

  componentDidMount() {
    this.store.dispatch(getOverviewInfo());
  }

  render() {
    return (
      <Provider store={this.store}>
        <OverviewInfoContent
          {...this.props}
        />
      </Provider>
    );
  }
}

OverviewInfo.displayName = 'OverviewInfo';

export default OverviewInfo;
